module.exports = __webpack_public_path__ + "static/media/icon-celeste-star.af2ec27b.svg";